import { render, staticRenderFns } from "./ui_checkbox.vue?vue&type=template&id=84242b80&scoped=true&"
import script from "./ui_checkbox.vue?vue&type=script&lang=js&"
export * from "./ui_checkbox.vue?vue&type=script&lang=js&"
import style0 from "./ui_checkbox.vue?vue&type=style&index=0&id=84242b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84242b80",
  null
  
)

export default component.exports